module.exports = __webpack_public_path__ + "img/blue_122.3b4ab1dd.png";